const defaultState = {
  name: '',
};

export default defaultState;
